import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useNavigate, useLocation } from 'react-router-dom'
import Loader from 'shared-ui/components/UI/Loader.jsx'

export default function Terms({ onBack }) {
  const navigate = useNavigate()
  const location = useLocation()
  const iframeRef = useRef(null)
  const [isLoading, setIsLoading] = useState(true)

  const handleBack = () => {
    if (onBack) {
      onBack()
    } else if (location.state?.prevLocation) {
      navigate(location.state.prevLocation, { state: location.state })
    } else {
      navigate(-1)
    }
  }

  const handleLoad = () => {
    setIsLoading(false)

    const iframe = iframeRef.current
    try {
      const doc = iframe.contentWindow.document
      const backBtn = doc.querySelector('.back-button')
      if (backBtn) {
        // remove existing click handlers
        backBtn.onclick = null
        backBtn.removeAttribute('onclick')

        // Attach new click handler
        backBtn.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()
          handleBack()
        })
      }
    } catch (err) {
      // Cannot access iframe content
    }
  }

  return (
    <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Loader />
        </div>
      )}
      <iframe
        ref={iframeRef}
        src="/terms.html"
        title="Terms and Conditions"
        onLoad={handleLoad}
        style={{
          width: '100%',
          height: '100vh',
          border: 'none',
          visibility: isLoading ? 'hidden' : 'visible'
        }}
      />
    </div>
  )
}

Terms.propTypes = {
  onBack: PropTypes.func
}
